import { render, staticRenderFns } from "./ReportWasteDocument.vue?vue&type=template&id=6eff5c35&scoped=true&"
import script from "./ReportWasteDocument.vue?vue&type=script&lang=js&"
export * from "./ReportWasteDocument.vue?vue&type=script&lang=js&"
import style0 from "./ReportWasteDocument.vue?vue&type=style&index=0&id=6eff5c35&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eff5c35",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCombobox,VDataTable,VDivider,VIcon,VLayout,VSelect,VSpacer,VTextField})
